import { Link as LinkIcon, ImageOff, Check } from "lucide-react";

export default function DesignCard({ item, onClick, selectionMode = false, selected = false }) {
  return (
    <button
      onClick={onClick}
      className={`group relative aspect-square rounded-lg overflow-hidden text-left transition-all ${
        selected ? "ring-2 ring-indigo-400 scale-[0.96]" : "hover:scale-[1.02]"
      }`}
      style={{ background: "var(--bg-input)", border: "1px solid var(--border-input)" }}
    >
      {item.imageUrl ? (
        <img
          src={item.imageUrl}
          alt={item.caption || item.title || ""}
          className="absolute inset-0 w-full h-full object-cover"
          loading="lazy"
        />
      ) : (
        <div className="absolute inset-0 flex items-center justify-center text-gray-600">
          <ImageOff className="w-8 h-8" />
        </div>
      )}

      {/* Link badge */}
      {item.type === "link" && (
        <div className="absolute top-2 right-2 p-1 rounded-md bg-black/60 backdrop-blur-sm">
          <LinkIcon className="w-3 h-3 text-blue-300" />
        </div>
      )}

      {/* Selection overlay */}
      {selectionMode && (
        <div
          className={`absolute top-2 left-2 w-7 h-7 md:w-6 md:h-6 rounded-md flex items-center justify-center transition-colors ${
            selected ? "bg-indigo-500" : "bg-black/70 backdrop-blur-sm border border-white/40"
          }`}
        >
          {selected && <Check className="w-4 h-4 text-white" />}
        </div>
      )}

      {/* Bottom gradient + tags */}
      {(item.tags?.length > 0 || item.title) && (
        <div className="absolute inset-x-0 bottom-0 p-2 bg-gradient-to-t from-black/85 via-black/40 to-transparent">
          {item.title && item.type === "link" && (
            <p className="text-[10px] text-gray-200 truncate mb-1">{item.title}</p>
          )}
          {item.tags?.length > 0 && (
            <div className="flex flex-wrap gap-1">
              {item.tags.slice(0, 3).map((tag) => (
                <span
                  key={tag}
                  className="text-[9px] px-1.5 py-0.5 rounded-full bg-indigo-500/40 text-indigo-100"
                >
                  {tag}
                </span>
              ))}
              {item.tags.length > 3 && (
                <span className="text-[9px] px-1.5 py-0.5 rounded-full bg-white/[0.1] text-gray-300">
                  +{item.tags.length - 3}
                </span>
              )}
            </div>
          )}
        </div>
      )}
    </button>
  );
}
